import {
  titleUI,
  yesNoUI,
  yesNoSchema,
  dateOfDeathUI,
  dateOfDeathSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { validations } from '../../../../config/validations';
import content from '../../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI('Veteran’s death information'),
    diedOnDuty: yesNoUI({
      title: content['veteran-additional-died-on-duty'],
    }),
    veteranDateOfDeath: dateOfDeathUI({
      validations: [validations.isAfterVeteranBirthDate],
    }),
  },
  schema: {
    type: 'object',
    required: ['diedOnDuty', 'veteranDateOfDeath'],
    properties: {
      diedOnDuty: yesNoSchema,
      veteranDateOfDeath: dateOfDeathSchema,
    },
  },
};
